// extracted by mini-css-extract-plugin
export default {"quote":"Quote_quote__-CS3R","quoteLight":"Quote_quoteLight__Olxtb","name":"Quote_name__DVkw9","quoteItem":"Quote_quoteItem__verLA"};